<template>
  <section>
    <div v-if="finishedLoading && !shouldFetchMoreRecords">
      <div class="columns column is-full team-filters">
        <b-field class="column" label="Filter by month">
          <multiselect
            v-model="filter.monthQuery"
            :options="datesWithMoment"
            track-by="text"
            label="text"
            :multiple="false"
            :close-on-select="true"
            :preserve-search="true"
            placeholder="Choose a month"
            :preselect-first="false"
          >
          </multiselect>
        </b-field>

        <b-field class="column" label="Filter by created/updated">
          <multiselect
            v-model="filter.creationOptions"
            :options="creationOptions"
            track-by="text"
            label="text"
            :multiple="false"
            :close-on-select="true"
            :preserve-search="true"
            placeholder="Choose a month"
            :preselect-first="false"
          >
          </multiselect>
        </b-field>

        <b-field class="column" label="Filter by student intakes">
          <multiselect
            v-model="filter.intake"
            :options="availableIntakes"
            track-by="value"
            label="value"
            :multiple="false"
            :close-on-select="true"
            :preserve-search="true"
            placeholder="Filter by student intakes"
            :preselect-first="false"
          >
          </multiselect>
        </b-field>

        <b-field class="column" label="Status">
          <multiselect
            v-model="filter.status"
            :options="availableStatus"
            track-by="value"
            label="value"
            :multiple="true"
            :close-on-select="false"
            :clear-on-select="false"
            :preserve-search="true"
            placeholder="Choose one or more status"
            :preselect-first="false"
          >
            <template slot="tag" slot-scope="{ option, remove }">
              <span :class="getRowClass(option.value, false)">
                <span>{{ option.value }}</span>
                <span class="multiselect__tag-icon" @click="remove(option)">
                </span>
              </span>
            </template>
          </multiselect>
        </b-field>

        <b-field v-if="isManager" class="column" label="Filter by teams">
          <multiselect
            v-model="filter.team"
            :options="availableTeams"
            track-by="teamId"
            label="teamName"
            :multiple="false"
            :close-on-select="true"
            :preserve-search="true"
            placeholder="Filter by teams"
            :preselect-first="false"
          >
          </multiselect>
        </b-field>

        <b-button class="align-self-center" @click="resetFilters()"
          >Reset</b-button
        >
      </div>

      <b-progress :max="countStatus.total" show-value class="column is-full">
        <template #bar>
          <b-progress-bar
            :value="countStatus.danger"
            type="is-danger"
            show-value
            >{{ countStatus.danger }} rejected</b-progress-bar
          >
          <b-progress-bar :value="countStatus.none" type="is-warning" show-value
            >{{ countStatus.none }} pending</b-progress-bar
          >
          <b-progress-bar
            :value="countStatus.success"
            type="is-success"
            show-value
            >{{ countStatus.success }} unconditional</b-progress-bar
          >
        </template>
      </b-progress>
      <b-message
        class="message-hide-close"
        :title="`${countStatus.total} students total`"
        type="is-warning"
      >
      </b-message>
      <div
        class="tl-content"
        v-for="(app, index) in teamMemberApplications"
        :key="index"
      >
        <p>
          <b>Team: {{ getTeamById(index) }} </b>
        </p>
        <div
          v-for="(advisorApplications, appIndex) in teamMemberApplications[
            index
          ]"
          class="tl-content__memeber"
          :key="appIndex"
        >
          <span>
            <b @click="setTeamUserModal(appIndex, index)"
              >{{ formatUsername(appIndex) }} ({{ advisorApplications.length }})
            </b>
            <b-icon
              type="is-success"
              size="is-small"
              icon="timetable"
              @click.native.prevent="
                setTimeUserSpent(getIdByUsername(appIndex), [])
              "
            ></b-icon>
          </span>
        </div>
      </div>
      <TimeChart
        v-if="selectedUserTime.length"
        :selectedUserTime="selectedUserTime"
        @closeAdvisor="setTimeUserSpent(null, [])"
      />
      <b-modal
        v-model="teamUsersModal.selected"
        :width="800"
        v-if="teamUsersModal.teamId"
      >
        <div
          class="py-2"
          v-for="(app, appsIndex) in teamMemberApplications[
            teamUsersModal.teamId
          ][teamUsersModal.moderator]"
          :key="appsIndex"
        >
          <router-link
            class="student__router-link"
            :to="{
              name: 'edit-student',
              params: {
                id: app.studentId,
                applicationId: app.applicationId,
                routeIsEdit: false,
              },
            }"
          >
            <user-card class="user__label" :application="app"></user-card>
          </router-link>
        </div>
      </b-modal>
    </div>

    <student-loader
      v-else
      :finishedLoading="!finishedLoading || shouldFetchMoreRecords"
    />
  </section>
</template>

<script>
import TeamService from '../services/team.service.js';
import AdminService from '../services/admin.service';
import UserCard from './helpers/UserCard.vue';
import {
  datesWithMoment,
  statusOptions,
  statusOptionsClasses,
} from '../models/static';
import moment from 'moment';
import UtilService from '../services/util';
import TimeChart from './admin/TimeChart.vue';
import Multiselect from 'vue-multiselect';
import StudentLoader from './helpers/StudentLoader.vue';
export default {
  components: {
    UserCard,
    TimeChart,
    Multiselect,
    StudentLoader,
  },
  name: 'team-list',
  data() {
    return {
      isOpen: null,
      finishedLoading: false,
      teamUsersModal: {
        selected: false,
        teamId: null,
        moderator: null,
      },
      filter: {
        monthQuery: null,
        intake: null,
        team: null,

        status: null,
        creationOptions: {
          text: 'Both',
          value: null,
        },
      },
      creationOptions: [
        {
          text: 'Both',
          value: null,
        },
        {
          text: 'Created at',
          value: true,
        },
        {
          text: 'Updated at',
          value: false,
        },
      ],
      team: [],
      teamMemberApplications: [],
      teamCopy: [],
      datesWithMoment: [],
      avaialableTeams: [],
      countStatus: {
        danger: 0,
        success: 0,
        none: 0,
        total: 0,
      },
      selectedUserTime: [],
    };
  },
  computed: {
    currentUser() {
      return this.$store.state.auth.user;
    },
    isManager() {
      return UtilService.isManager();
    },
    availableIntakes() {
      return this.$store.state.application_filter.filterOptions.intake;
    },

    shouldFetchMoreRecords() {
      return (
        this.$store.state.application.offset <
        this.$store.state.application.totalNoApplcations
      );
    },

    availableTeams() {
      const avaialableTeams = this.team.map((team) => {
        return {
          teamId: team.teamId,
          teamName: team.teamName,
        };
      });

      return [
        ...new Map(
          avaialableTeams.map((item) => [item['teamId'], item])
        ).values(),
      ];
    },
    availableStatus() {
      return ['All', 'None', ...statusOptions].map((value) => {
        return {
          value,
        };
      });
    },
  },
  mounted() {
    this.datesWithMoment = datesWithMoment;
    if (!this.shouldFetchMoreRecords) {
      this.getTeamLeaderTeams();
    }
  },
  watch: {
    filter: {
      handler() {
        this.changedTeamleaderQuery();
      },
      deep: true,
    },

    shouldFetchMoreRecords(newValue) {
      if (!newValue) {
        this.getTeamLeaderTeams();
      }
    },
    deep: true,
  },
  methods: {
    getTeamLeaderTeams() {
      TeamService.getTeamLeaderTeams({
        id: this.currentUser.id,
      }).then((response) => {
        this.team = response.data.flat(1).map((team) => ({
          teamId: team.teamId,
          isManager: team.isManager,
          teamName: team.team.name,
        }));
        this.teamMemberApplications = response.data
          .flat(1)
          .reduce((acc, team) => {
            const teamId = team.teamId;
            const moderator = team.user.username;
            if (!acc[teamId]) {
              acc[teamId] = {};
            }
            if (!acc[teamId][moderator]) {
              acc[teamId][moderator] = [];
            }

            return acc;
          }, {});

        const copyApplications = this.$store.state.application.applications;
        this.populateStudentApplications(
          copyApplications.map((app) => ({ ...app }))
        );
        this.finishedLoading = true;
      });
    },

    countTeamStats() {
      let mergedArray = [];
      Object.values(this.teamMemberApplications).forEach((userGroup) => {
        Object.values(userGroup).forEach((userEntries) => {
          mergedArray = mergedArray.concat(userEntries);
        });
      });
      mergedArray = mergedArray.map((app) => app.status);
      const danger = mergedArray.filter((res) => res === 'Rejected').length;
      const success = mergedArray.filter(
        (res) =>
          res === 'Unconditional' ||
          res === 'Awaiting Uncon' ||
          res === 'Pending'
      ).length;
      const none = mergedArray.length - danger - success;

      this.countStatus = {
        danger,
        success,
        none,
        total: mergedArray.length,
      };
    },

    populateStudentApplications(newApps) {
      const copyNewApps = newApps.map((app) => ({ ...app }));

      copyNewApps.reduce((acc, app) => {
        const moderator = app.moderator || 'Unassigned';
        const teamId = app.team.teamId;
        if (!acc) return;

        if (!acc[teamId]) {
          acc[teamId] = {};
        }

        if (!acc[teamId][moderator]) {
          acc[teamId][moderator] = [];
        }

        const studentValue = {
          applicationId: app.id,
          studentId: app.studentId,
          courseTitle: app.courseTitle,
          status: app.status,
          isApproved: app.isApproved,
          intake: app.intake,
          isDraft: app.isDraft,
          studentName: app.studentData.personalInformation.student_name,
          moderatorId: app.moderatorId,
          createdAt: app.createdAt,
          updatedAt: app.updatedAt,
        };

        const alreadyExists = this.teamMemberApplications[teamId][
          moderator
        ].find(
          (student) => student.applicationId === studentValue.applicationId
        );

        if (alreadyExists) {
          return;
        }

        this.teamMemberApplications[teamId][moderator].push(studentValue);
        acc[teamId][moderator].push(studentValue);
        return acc;
      }, {});

      this.teamMemberApplications = Object.keys(
        this.teamMemberApplications
      ).reduce((acc, teamId) => {
        acc[teamId] = Object.keys(this.teamMemberApplications[teamId])
          .sort(
            (a, b) =>
              this.teamMemberApplications[teamId][b].length -
              this.teamMemberApplications[teamId][a].length
          )
          .reduce((sortedAcc, moderator) => {
            sortedAcc[moderator] =
              this.teamMemberApplications[teamId][moderator];
            return sortedAcc;
          }, {});
        return acc;
      }, {});

      this.teamCopy = UtilService.deepCopy(this.teamMemberApplications);
      this.countTeamStats();
    },

    getTeamById(id) {
      const intId = parseInt(id);
      return this.team.find((team) => team.teamId === intId).teamName;
    },

    getIdByUsername(username) {
      return UtilService.getIdByUsername(username);
    },

    setTeamUserModal(moderator, teamId) {
      this.teamUsersModal = {
        selected: true,
        moderator,
        teamId,
      };
    },

    formatUsername(username) {
      return UtilService.visualUsername(username);
    },

    resetFilters() {
      this.filter = {
        monthQuery: null,
        intake: null,
        team: null,
        status: null,
        creationOptions: {
          text: 'Both',
          value: null,
        },
      };

      this.teamMemberApplications = UtilService.deepCopy(this.teamCopy);
    },

    async setTimeUserSpent(id, selectedUserTime) {
      let timeSpent = selectedUserTime;

      if (id) {
        await AdminService.getUserTimeSpent(id).then((response) => {
          timeSpent = response.data.length
            ? response.data.sort((a, b) => {
                return new Date(b.updatedAt) - new Date(a.updatedAt);
              })
            : [];
        });
      }

      this.selectedUserTime = [];
      setTimeout(() => {
        this.selectedUserTime = timeSpent;
      }, 100);
    },

    changedTeamleaderQuery() {
      let teamCopy = UtilService.deepCopy(this.teamCopy);
      if (this.filter.monthQuery) {
        teamCopy = this.filterApplications(teamCopy, 'month');
      }

      if (this.filter.intake) {
        teamCopy = this.filterApplications(teamCopy, 'intake');
      }

      if (this.filter.status) {
        teamCopy = this.filterApplications(teamCopy, 'status');
      }

      if (this.isManager && this.filter.team && this.filter.team.teamId) {
        teamCopy = {
          [this.filter.team.teamId]: teamCopy[this.filter.team.teamId],
        };
      }

      this.teamMemberApplications = teamCopy;
      this.countTeamStats();
    },

    filterApplications(jsonData, filterType) {
      let filteredData = {};

      Object.entries(jsonData).forEach(([groupKey, userGroup]) => {
        let filteredUsers = {};

        Object.entries(userGroup).forEach(([userKey, userEntries]) => {
          const bookedEntries = userEntries.filter((entry) => {
            switch (filterType) {
              case 'month':
                return this.filterByDate(entry);

              case 'intake':
                return this.filterByIntake(entry);

              case 'status':
                return this.filterByStatus(entry);

              default:
                break;
            }
          });

          if (bookedEntries.length > 0) {
            filteredUsers[userKey] = bookedEntries;
          }
        });

        if (Object.keys(filteredUsers).length > 0) {
          filteredData[groupKey] = filteredUsers;
        }
      });

      return filteredData;
    },

    filterByDate(entry) {
      {
        const recordTime =
          this.filter.creationOptions !== null
            ? moment(
                this.filter.creationOptions ? entry.createdAt : entry.updatedAt
              )
            : null;
        return this.filter.monthQuery
          ? this.filter.creationOptions === null
            ? (this.filter.monthQuery.month ===
                moment(entry.createdAt).month() &&
                this.filter.monthQuery.year ===
                  moment(entry.createdAt).year()) ||
              (this.filter.monthQuery.month ===
                moment(entry.updatedAt).month() &&
                this.filter.monthQuery.year === moment(entry.updatedAt).year())
            : this.filter.monthQuery.month === recordTime.month() &&
              this.filter.monthQuery.year === recordTime.year()
          : true;
      }
    },

    filterByIntake(teamApp) {
      return teamApp.intake !== null
        ? teamApp.intake === this.filter.intake.value
        : true;
    },

    filterByStatus(teamApp) {
      return this.filter.status && this.filter.status.length
        ? this.filter.status.some((docFilter) => {
            return docFilter.value === 'All'
              ? true
              : docFilter.value === 'None'
              ? teamApp.status === ''
              : teamApp.status === docFilter.value;
          })
        : true;
    },

    filterByTeam(team) {
      return team.teamId ? team.teamId === this.filter.team.teamId : true;
    },

    getRowClass(row, isObject) {
      const statusToCheck = isObject ? row.status : row;
      const rowStatus =
        statusToCheck && !statusOptionsClasses[statusToCheck]
          ? 'status-nude'
          : statusOptionsClasses[statusToCheck];
      const rowClass = isObject
        ? `app-table__row ${rowStatus}`
        : `multiselect__tag status-tag ${rowStatus}`;
      return {
        [rowClass]: true,
      };
    },
  },
};
</script>

<style>
.student-status-tl {
  padding: 8px 12px;
  border-radius: 8px;
  margin: 6px 0;
}

.team-filters {
  align-items: flex-start;
}

.tl-content {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;

  margin-top: 24px;
}

.tl-content > p {
  flex: 1 1 100%;
}

.tl-content__memeber {
  padding: 8px 12px;
  border-radius: 8px;
  box-shadow: rgba(0, 0, 0, 0.1) 0px 4px 12px;
  cursor: pointer;
  color: #636060;
}

.user__label {
  box-shadow: rgba(0, 0, 0, 0.1) 0px 4px 12px;
  border: none;
  border-radius: 8px;
}

.user__label .ag-courses-item_link {
  justify-content: space-between;
}

a.student__router-link {
  text-decoration: none;
}

.user__label:hover {
  background-color: #c1c1c1;
}
</style>
